import { useMatches } from "react-router-dom";

export type Crumbs = { label: string; pathname: string };
export const useBreadcrumbs = () => {
  const matches = useMatches();
  const crumbs = matches.reduce<Crumbs[]>((crumbs, match) => {
    const currMatch = match as { handle?: { label?: string }; pathname: string };
    if (currMatch.handle?.label) return crumbs.concat({ label: currMatch.handle.label, pathname: currMatch.pathname });
    return crumbs;
  }, []);

  return crumbs;
};
